import { useState, FC, useEffect, useMemo } from 'react';
import { useRestartPhaseMutation, useSendTaskMutation, useUpdateTaskDeadlineMutation } from '../../api/tenders';
import { SupplierI, taskProps, tenderDataProps } from '../../pages/TenderViewPage/types';
import { Button, Tooltip, message, Modal } from 'antd';
import { useAppSelector } from '../../hooks';
import LetterIcon from '../../assets/LetterIcon.svg';
import Notif from '../../assets/Notif.svg';
import arrow from '../../assets/arrow-right-white.svg';
import calendar from '../../assets/calendar-chedule.svg';
import restartPhaseImage from '../../assets/restartPhaseBtn.svg';

import attention from '../../assets/attention.svg';
import moment from 'moment';
import { TaskDeadlineModal } from '../Modals/TaskDeadline';
import './phases.scss';
import { MultiAwardModal } from '../Modals/MultiAwardModal';
import { MultiAward } from './EvaluatePhase4Components/MultiAward';
import { SupplierListNew } from './DesignPhaseComponents/SupplierListNew';
import { Loader } from '../Loader/Loader';
import { PriceBreakdown } from './EvaluatePhase4Components/PriceBreakdown';
import { AllTasksCompleted } from './AllTasksCompleted';

interface PropsPhase {
    data: tenderDataProps;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
    setConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const EvaluatePhase4: FC<PropsPhase> = ({ data, setTrigger, setConfirmModal }) => {
    const { role } = useAppSelector((state) => state.profileReducer);
    const [screenWidth, setScreenWidth] = useState<number>(window.screen.width);
    function handleResize() {
        setScreenWidth(window.screen.width);
    }
    window.addEventListener('resize', handleResize);

    const [restartPhase, { data: dataRestart, isSuccess, isLoading: isLoadingRestart }] = useRestartPhaseMutation();

    const [deadlineModal, setDeadlineModal] = useState(false);
    const [SelectedDate, setSelectedDate] = useState<Date | string>(new Date());
    const [isMultiAward, setIsMultiAward] = useState(false);
    const [isRestartModal, setIsRestartModal] = useState(false);

    const [updateDeadline, { isLoading }] = useUpdateTaskDeadlineMutation();

    const updateDeadlineFunc = async () => {
        try {
            const formData = {
                id: data.id,
                data: { deadline_at: moment(SelectedDate).format('YYYY-MM-DD') }
            };
            await updateDeadline(formData).unwrap();
            await setDeadlineModal(false);
            await setTrigger((prev: boolean) => !prev);
        } catch {}
    };

    const [
        sendTask,
        { data: dataSendTask, isError: isErrorSendTask, isSuccess: isSuccessSendTask, isLoading: isLoadingSendTask }
    ] = useSendTaskMutation();

    const [messageApi, contextHolder] = message.useMessage();

    const sendTaskFunc = async () => {
        const formData = {
            id: data?.id
        };
        try {
            await sendTask(formData).unwrap();
        } catch {}
    };

    useEffect(() => {
        if (isSuccess) {
            messageApi.success(dataRestart.message);
            setIsRestartModal(false);
            setTrigger((prev) => !prev);
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isErrorSendTask) {
            messageApi.error('Something went wrong, please try again');
        }
        if (isSuccessSendTask) {
            messageApi.success(dataSendTask.message);
            setTrigger((prev) => !prev);
        }
    }, [isErrorSendTask, isSuccessSendTask]);

    const evaluation_4_price_breakdown = data?.phase_tasks.find(
        (elem: taskProps) => elem.action === 'evaluation_4_price_breakdown'
    );
    const evaluate_4_suppliers = data?.phase_tasks.find((elem: taskProps) => elem.action === 'evaluate_4_suppliers');

    const { canNotifyPreferredSupplier, notifyPreferredSupplierTooltip, shortlistedSuppliersCount } = useMemo(() => {
        const suppliers: SupplierI[] = data?.suppliers ?? [];
        const allEvaluationFinal =
            suppliers.length > 0 && suppliers.every((s) => s.status === 'rejected' || s.status === 'shortlisted');
        const shortlisted = suppliers.filter((s) => s.status === 'shortlisted');
        const hasShortlisted = shortlisted.length > 0;
        const canNotify = allEvaluationFinal && hasShortlisted;
        const tooltip = !allEvaluationFinal
            ? 'To send this task, you need to complete all the Task Activities'
            : !hasShortlisted
            ? 'At least one supplier must be awarded'
            : undefined;
        return {
            canNotifyPreferredSupplier: canNotify,
            notifyPreferredSupplierTooltip: tooltip,
            shortlistedSuppliersCount: shortlisted.length
        };
    }, [data?.suppliers]);

    const trShowGenerateMatchmaking = evaluation_4_price_breakdown?.status === 'pending_tr';
    const trShowProceedToAward = evaluate_4_suppliers?.status === 'completed';

    const tenderRepPhaseActions =
        role === 'tender_representative' ? (
            <div className="tasks__btn-wrap">
                <div style={{ width: '47%' }}>
                    <div className="tasks__resend withoutBorder" onClick={() => setIsRestartModal(true)}>
                        <img src={restartPhaseImage} alt="" />
                        Restart Phase
                    </div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        gap: 12,
                        flex: 1,
                        minWidth: 0
                    }}
                >
                    {trShowGenerateMatchmaking && (
                        <Tooltip
                            title={
                                !data?.can_send_task
                                    ? 'To Generate Matchmaking Report, you must complete all tasks first!'
                                    : ''
                            }
                            overlayClassName={` ${!data?.can_send_task ? 'custom-tooltip-disabled' : 'custom-tooltip'}`}
                        >
                            <Button
                                className={`tasks__next-btn ${data?.can_send_task ? '' : 'disabled'}`}
                                type="primary"
                                style={{ width: '300px' }}
                                onClick={() => {
                                    if (!data?.can_send_task) return;
                                    if (!isLoadingSendTask) sendTaskFunc();
                                }}
                            >
                                {isSuccessSendTask ? (
                                    <Loader />
                                ) : (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        Generate Matchmaking Report <img src={arrow} alt="" />
                                    </div>
                                )}
                            </Button>
                        </Tooltip>
                    )}
                    {trShowProceedToAward && (
                        <Button
                            className={`tasks__next-btn ${data.can_update_phase ? '' : 'disabled'}`}
                            style={{ width: '200px' }}
                            type="primary"
                            onClick={() => {
                                if (data.can_update_phase) setConfirmModal(true);
                            }}
                        >
                            Proceed to Award <img src={arrow} alt="" />
                        </Button>
                    )}
                </div>
            </div>
        ) : null;

    const taskHeaderDeadlineAt = role === 'school_user' ? data?.tasks_deadline_at : data?.phase_deadline_at;

    return (
        <>
            {contextHolder}
            <div className={`tendermain__block tasks`}>
                <div className="tasks__header define">
                    <div className="count-wrapper">
                        Task Centre
                        <div className="count">{data?.phase_task_count}</div>
                    </div>
                    {taskHeaderDeadlineAt && (
                        <div className="tasks__deadline-wrapper">
                            <img src={attention} alt="" />
                            Task Deadline - {moment(taskHeaderDeadlineAt).format('YYYY-MM-DD')}
                        </div>
                    )}
                </div>

                <div className="tasks__list">
                    {role !== 'school_user' && data?.tasks_deadline_at && (
                        <div className="tasks__info-wrap info-wrap" style={{ margin: '0 0 16px 0' }}>
                            <div className="info-wrap__deadline">Task Deadline for Buyer</div>
                            <div className="info-wrap__status">
                                {moment(data?.tasks_deadline_at).format('YYYY-MM-DD')}
                            </div>
                        </div>
                    )}
                    {data.phase_tasks.length ? (
                        <>
                            {role === 'school_user' &&
                                data?.phase_tasks?.length > 0 &&
                                data?.phase_tasks?.every((elem: taskProps) => elem.status === 'completed') && (
                                    <AllTasksCompleted />
                                )}
                            <PriceBreakdown data={data} role={role} setTrigger={setTrigger} messageApi={messageApi} />
                            <SupplierListNew data={data} role={role} messageApi={messageApi} setTrigger={setTrigger} />
                            <MultiAward data={data} />
                        </>
                    ) : (
                        <>
                            {role === 'school_user' && !data.tasks_deadline_at && (
                                <div className="noTasks">
                                    <img src={LetterIcon} />
                                    <div className="noTasks__title">Welcome to Evaluation Gate 3!</div>
                                    <div className="noTasks__subtitle">
                                        Watch this space - new tasks for you will be posted here as they become
                                        available.
                                    </div>
                                </div>
                            )}
                            {role === 'school_user' && data.tasks_deadline_at && (
                                <div className="noTasks">
                                    <img src={Notif} />
                                    <div className="noTasks__title">Negotiations are currently in progress</div>
                                    <div className="noTasks__subtitle" style={{ width: '395px' }}>
                                        The results of these discussions will be published on
                                    </div>
                                    <div className="noTasks__date">
                                        <img src={calendar} className="noTasks__image" />{' '}
                                        {moment(data.tasks_deadline_at).format('DD MMMM, YYYY')}
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>

                {tenderRepPhaseActions}

                {role === 'school_user' &&
                    data?.phase_tasks?.find((elem: taskProps) => elem.action === 'evaluate_4_suppliers')?.status !==
                        'completed' && (
                        <div className="tasks__btn-wrap">
                            <div></div>

                            <Tooltip
                                title={notifyPreferredSupplierTooltip}
                                overlayClassName={
                                    !canNotifyPreferredSupplier ? 'custom-tooltip-disabled' : 'custom-tooltip'
                                }
                            >
                                <span style={{ display: 'inline-block' }}>
                                    <Button
                                        className={`tasks__next-btn ${canNotifyPreferredSupplier ? '' : 'disabled'}`}
                                        type="primary"
                                        style={{ width: '250px' }}
                                        disabled={
                                            !canNotifyPreferredSupplier ||
                                            (shortlistedSuppliersCount === 1 && isLoadingSendTask)
                                        }
                                        onClick={() => {
                                            if (!canNotifyPreferredSupplier) return;
                                            if (shortlistedSuppliersCount === 1) {
                                                void sendTaskFunc();
                                            } else {
                                                setIsMultiAward(true);
                                            }
                                        }}
                                    >
                                        {shortlistedSuppliersCount === 1 && isLoadingSendTask ? (
                                            <Loader />
                                        ) : (
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                Notify Preferred Supplier
                                                <img src={arrow} alt="" />
                                            </div>
                                        )}
                                    </Button>
                                </span>
                            </Tooltip>
                        </div>
                    )}
            </div>
            {deadlineModal && (
                <TaskDeadlineModal
                    openModal={deadlineModal}
                    setOpenModal={setDeadlineModal}
                    SelectedDate={SelectedDate}
                    setSelectedDate={setSelectedDate}
                    updateDeadlineFunc={updateDeadlineFunc}
                    isLoading={isLoading}
                    data={data}
                />
            )}
            {isMultiAward && (
                <MultiAwardModal
                    data={data}
                    openModal={isMultiAward}
                    setOpenModal={setIsMultiAward}
                    setTrigger={setTrigger}
                />
            )}
            {isRestartModal && (
                <Modal
                    className="confirmModal"
                    centered
                    open={isRestartModal}
                    closeIcon={<div style={{ display: 'none', cursor: 'context-menu' }}></div>}
                    width={600}
                    footer={
                        <div style={{ display: 'flex', justifyItems: 'space-between', gap: '16px', width: '100%' }}>
                            <Button key="back" onClick={() => setIsRestartModal(false)} block className="cancel">
                                Cancel
                            </Button>
                            <Button
                                className={`tasks__next-btn`}
                                style={{ width: '100%' }}
                                type="primary"
                                onClick={() => {
                                    if (isLoadingRestart) return;
                                    restartPhase({ tender_id: data?.id });
                                }}
                            >
                                {isLoadingRestart ? <Loader /> : 'Yes'}
                            </Button>
                        </div>
                    }
                >
                    <div className="modal">
                        <div className="modal__header" style={{ height: '125px' }}>
                            <div className="modal__title">
                                Are you sure you want to restart <br />
                                the {data?.phase_name} phase?
                            </div>
                        </div>

                        <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                            <div className="main__title" style={{ margin: '0 0 6px 0' }}>
                                This action cannot be undone. Do you want to continue?
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};
